import * as Yup from "yup";

import {
  CreateEmployeeAccount,
  CreateEmployeeAccountVariables,
} from "_graphql/mutation/__generated__/CreateEmployeeAccount";
import { gql, useMutation } from "@apollo/client";
import { validators, wrapClick } from "utils";

import { EmployeeForm } from "components/forms";
import { Modal } from "components";
import _ from "lodash";
import { createEmployee } from "_graphql/visal/mutations/employee";
import { getDomain } from "router/filter";
import toast from "react-hot-toast";
import { useFormik } from "formik";

export const employeeValidationSchema = Yup.object().shape({
  domain: Yup.string().required("Domain is required"),
  employee_first_name: Yup.string().required("First name is required"),
  employee_last_name: Yup.string().required("Last name is required"),
  employee_phonenumber: Yup.string().required("Phone number is required"),
  employee_email: Yup.string().required("Email is required"),
  employee_position: Yup.string().required("Position is required"),
});

export default function CreateEmployeeContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const [create, { loading }] = useMutation<
    CreateEmployeeAccount,
    CreateEmployeeAccountVariables
  >(createEmployee);
  const domain = getDomain();
  const form = useFormik<any["employee"]>({
    initialValues: {
      employee_email: "",
      employee_first_name: "",
      employee_last_name: "",
      employee_phonenumber: "",
      employee_position: "",
      user_role_id: "",
    },
    validationSchema: employeeValidationSchema,
    onSubmit: async (variables) => {
      await create({
        variables: {
          employee: _.omitBy(
            {
              ..._.omit(variables, ["domain"]),
              employee_position: variables.user_role_id?.position,
              user_role_id: variables.user_role_id?.user_role_id,
            },
            _.isUndefined
          ) as any,
        },
      }).then(({ data }) => {
        if (data?.createEmployeeAccount) {
          toast.success("Employee created successfully");
          refetch?.();
          form.resetForm();
        } else {
          toast.error("Failed to create employee");
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Add New Employee"
      description="Provide the details to add a new employee"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Adding Employee..." : "Add Employee"}
          </button>
        </>
      )}
    >
      <EmployeeForm form={form} />
    </Modal>
  );
}
